
  import { defineComponent, PropType } from 'vue';
  import { mapActions, mapGetters } from 'vuex';
  import { helpers } from '@vuelidate/validators';

  import { TFilter, TFilterConfig, TFilterTreeSelect } from '@/common/components/redesigned/Filter/types/filter';
  import { MenuModes } from '@/common/components/redesigned/TreeMultiselect/types';
  import { getYearMonthFlatOptions, getYearsFilterOptions } from '@/common/utils/options';

  import { COST_TYPE_FILTER_OPTIONS } from '../../constants/options';
  import { VED_COMMON_ACTIONS_NAME, VED_COMMON_GETTERS_NAME } from '../../store/vedCommon/name';
  import { TAnalyticsNotesFilter } from '../../types/analytics-notes';
  import FilterDetailsVed from '../common/FilterDetailsVed.vue';
  import FilterFactoryVed from '../common/FilterFactoryVed.vue';

  export default defineComponent({
    name: 'AnalyticsNotesFilter',
    components: {
      FilterDetailsVed,
      FilterFactoryVed,
    },
    emits: {
      searchFilter: (filter: TFilter) => filter,
      updateFilter: (filter: TFilter) => filter,
    },
    props: {
      defaultFilter: {
        type: Object as PropType<TAnalyticsNotesFilter>,
        required: true,
      },
      isMonthly: {
        type: Boolean,
        default: false,
      },
      readonlyPermissionCode: {
        type: Number,
      },
    },
    created() {
      this.searchCountriesTree();
    },
    computed: {
      ...mapGetters({
        getCountriesTree: VED_COMMON_GETTERS_NAME.getCountriesTree,
      }),
      getDefaultFactoryFilter(): TFilter {
        return this.defaultFilter;
      },
      getFiltersConfig(): TFilterConfig<TFilter>[] {
        const periodFilterConfig: TFilterTreeSelect = {
          type: 'tree-select',
          label: 'Период',
          options: this.isMonthly ? getYearMonthFlatOptions(2001) : getYearsFilterOptions(2001),
          vModel: 'periods',
          required: true,
          ...(this.isMonthly
            ? {
                isSingleMode: true,
                textError: undefined,
                customValidations: undefined,
                menuMode: MenuModes.NONE,
              }
            : {
                textError: 'Для расчета выберите минимум два периода',
                customValidations: {
                  minLength: helpers.withParams({ type: 'minLength' }, (value: string[]) => value.length >= 2),
                },
                menuMode: MenuModes.COMBINED_MODAL,
              }),
        };

        return [
          periodFilterConfig,
          {
            type: 'tree-select',
            label: 'Страна-партнер',
            options: this.getCountriesTree,
            vModel: 'country',
            required: true,
            isSingleMode: true,
            menuMode: MenuModes.COMBINED_MODAL,
          },
          {
            type: 'select',
            label: 'Стоимость в',
            options: COST_TYPE_FILTER_OPTIONS,
            vModel: 'costType',
            valueProp: 'value',
            labelProp: 'label',
            required: true,
          },
        ];
      },
    },
    methods: {
      ...mapActions({
        searchCountriesTree: VED_COMMON_ACTIONS_NAME.searchCountriesTree,
      }),
      searchFilter(filter: Partial<TAnalyticsNotesFilter>) {
        this.$emit('searchFilter', filter);
      },
      updateFilter(filter: Partial<TAnalyticsNotesFilter>) {
        this.$emit('updateFilter', filter);
      },
    },
  });
